import { reactive } from "vue";

const state = reactive({
  toasts: [],
  nextId: 0,
});

/**
 * Toast notification composable.
 * @returns {{ toasts: Array, showToast: Function, removeToast: Function }}
 */
export function useToast() {
  const showToast = (message, type = "info", duration = 3500) => {
    const id = state.nextId++;
    state.toasts.push({ id, message, type });

    // Keep max 3
    if (state.toasts.length > 3) {
      state.toasts.shift();
    }

    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id) => {
    const idx = state.toasts.findIndex((t) => t.id === id);
    if (idx !== -1) state.toasts.splice(idx, 1);
  };

  return {
    toasts: state.toasts,
    showToast,
    removeToast,
  };
}
